import { Content } from '@orobix/orobix-fe-components'

import { PageHeader } from '../../components/PageHeader/PageHeader'
import { withQueryErrorBoundary } from '../../components/QueryErrorBoundary/withQueryErrorBoundary'
import { IngestionStatusBanner } from './IngestionStatusBanner/IngestionStatusBanner'
import { NewOptimizationProcessButton } from './NewOptimizationProcessButton'
import { OptimizationProcessesList } from './OptimizationProcessesList/OptimizationProcessesList'

export const OptimizationProcessesRoot = withQueryErrorBoundary(() => (
  <Content>
    <PageHeader title="" right={<NewOptimizationProcessButton />} />

    <IngestionStatusBanner />

    <OptimizationProcessesList />
  </Content>
))
